import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  FormText,
} from "reactstrap";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { updateMachine } from "../../store/actions/machineActions";
import SweetAlert from "react-bootstrap-sweetalert";

class UpdateMachine extends Component {
  state = {
    id: "",
    UHANo: "",
    typeIdentity: "",
    model: "",
    name: "",
    unit: "",
    inputDisabled: true,
  };

  enableEditing = () => {
    this.setState({
      inputDisabled: false,

      UHANo: this.props.machine.UHANo,
      typeIdentity: this.props.machine.typeIdentity,
      model: this.props.machine.model,
      name: this.props.machine.name,
      unit: this.props.machine.unit,
      id: this.props.machine.id,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log(this.state);
    this.props.updateMachine(this.state);
  };

  infoAlert = () => {
    this.setState({
      alert: (
        <SweetAlert
          title="Machine Unit Info"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Ok"
          btnSize=""
        >
          {this.props.machine && this.props.machine.length !== 0 ? (
              <div style={{textAlign:'left'}}>
                  <p>{this.props.machine.unit ? (<span><b>Unit : </b> <span>{this.props.machine.unit}</span></span>): (null)}</p>
                  <p>{this.props.machine.location ? (<span><b>Location : </b> <span>{this.props.machine.location}</span></span>): (null)}</p>
                  <p>{this.props.machine.task ? (<span><b>Task : </b> <span>{this.props.machine.task}</span></span>): (null)}</p>
                  <p>{this.props.machine.status ? (<span><b>Status : </b> <span>{this.props.machine.status}</span></span>): (null)}</p>
                  <p>{this.props.machine.dateOffRd ? (<span><b>Date Off RD : </b> <span>{this.props.machine.dateOffRd}</span></span>): (null)}</p>
                  <p>{this.props.machine.remarks ? (<span><b>Remarks : </b> <span>{this.props.machine.remarks}</span></span>): (null)}</p>
              </div>
          ) : null}
        </SweetAlert>
      ),
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null,
    });
  };

  render() {
    const { machine, profile } = this.props;

    return (
      <>
        {machine && machine.length !== 0 ? (
          <Card>
            <CardBody>
              <CardTitle>
                <h5 className="text-center">Update Machine Details</h5>
              </CardTitle>
              {this.state.alert}
              <p>
                <b>UHA No :</b> {machine.UHANo}
              </p>
              <p>
                <b>Type Identity :</b> {machine.typeIdentity}
              </p>
              <p>
                <b>Model :</b> {machine.model}
              </p>
              <p>
                <b>Name :</b> {machine.name}
              </p>
              <p>
                <b>Unit :</b> {machine.unit}
              </p>
              <Button color="primary" outline block onClick={this.infoAlert} className="mb-4">
                View Machine Unit Status
              </Button>
              <hr/>
              <Button color="primary" block onClick={this.enableEditing} className="mt-4">
                Enable Edit
              </Button>
              {machine &&
              machine.length !== 0 &&
              profile.userType === "admin" ? (
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <FormText>UHA No</FormText>
                    <Input
                      required
                      type="text"
                      name="UHANo"
                      id="UHANo"
                      placeholder={machine.UHANo}
                      // onChange={this.handleChange}
                      disabled={true}
                      value={this.state.UHANo}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormText>Type Identity</FormText>
                    <Input
                      required
                      type="text"
                      name="typeIdentity"
                      id="typeIdentity"
                      placeholder={machine.typeIdentity}
                      onChange={this.handleChange}
                      disabled={this.state.inputDisabled}
                      value={this.state.typeIdentity}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormText>Model</FormText>
                    <Input
                      required
                      type="text"
                      name="model"
                      id="model"
                      placeholder={machine.model}
                      onChange={this.handleChange}
                      value={this.state.model}
                      disabled={this.state.inputDisabled}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormText>Machine Name</FormText>
                    <Input
                      required
                      type="text"
                      name="name"
                      id="name"
                      placeholder={machine.name}
                      onChange={this.handleChange}
                      value={this.state.name}
                      disabled={this.state.inputDisabled}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormText>
                      Current Unit : <b>{machine.unit}</b>
                    </FormText>
                    <FormText>Select New Unit</FormText>
                    <Input
                      required
                      type="select"
                      name="unit"
                      id="unit"
                      onChange={this.handleChange}
                      disabled={this.state.inputDisabled}
                    >
                      <option value="No Value">Select</option>
                      <option value="1 SLE">1 SLE</option>
                      <option value="2 SLE">2 SLE</option>
                      <option value="3 SLE">3 SLE</option>
                      <option value="4 SLE">4 SLE</option>
                      <option value="5 SLE">5 SLE</option>
                      <option value="6 SLE">6 SLE</option>
                      <option value="7 SLE">7 SLE</option>
                      <option value="8 SLE">8 SLE</option>
                      <option value="9 SLE">9 SLE</option>
                      <option value="10 SLE">10 SLE</option>
                      <option value="11 SLE">11 SLE</option>
                      <option value="12 SLE">12 SLE</option>
                      <option value="SLSME">SLSME</option>
                      <option value="WKSP">WKSP</option>
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Button
                      color="primary"
                      block
                      disabled={this.state.inputDisabled}
                    >
                      Update
                    </Button>
                  </FormGroup>
                </Form>
              ) : null}
            </CardBody>
          </Card>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.firebase.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateMachine: (machine) => dispatch(updateMachine(machine)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  UpdateMachine
);
